import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { State } from "country-state-city";

export default function FilterModal({
  show,
  onHide,
  stateFilter,
  setStateFilter,
  applyFilters,
  removeFilters,
  statusFilter,
  setStatusFilter,
  apidata,
}) {
  const [filteredCities, setFilteredCities] = useState([]);

  const getStateName = (stateCode) => {
    const state = State.getStateByCodeAndCountry(stateCode, "IN");
    return state ? state.name : stateCode;
  };

  useEffect(() => {
    if (stateFilter) {
      const cities = Array.from(
        new Set(
          apidata
            .filter((item) => item.state === stateFilter)
            .map((item) => item.city),
        ),
      ).filter(Boolean);
      setFilteredCities(cities);
    } else {
      const allCities = Array.from(
        new Set(apidata.map((item) => item.city)),
      ).filter(Boolean);
      setFilteredCities(allCities);
    }
  }, [stateFilter, apidata]);

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Filter Options</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="stateFilter">
            <Form.Label>State</Form.Label>
            <Form.Control
              as="select"
              value={stateFilter}
              onChange={(e) => setStateFilter(e.target.value)}
            >
              <option value="">All States</option>
              {State.getStatesOfCountry("IN").map((state, index) => (
                <option key={index} value={state.isoCode}>
                  {state.name}
                </option>
              ))}
            </Form.Control>
          </Form.Group>

          <Form.Group controlId="statusFilter">
            <Form.Label>Status</Form.Label>
            <Form.Control
              as="select"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="">All Status</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </Form.Control>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={removeFilters}>
          Remove Filters
        </Button>
        <Button variant="primary" onClick={applyFilters}>
          Apply Filters
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
